<template>
	<div>
		<Input v-model="checkCode" placeholder="请输入验证码" class="check-code-input" :style="inputStyle"
			@on-change="inputChange" />
		<div class="check-code-button">
			<Button @click="countdown" :disabled='countdownState'>{{countdownValue}}</Button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CheckCodeBox',
		props: {
			telephone: {
				type: String,
				default: ''
			},
			inputStyle: {
				type: Object,
				default: function(result) {
					return {}
				}
			}
		},
		data() {
			return {
				countdownValue: '获取验证码',
				countdownState: false,
				timeRemaining: 60,
				checkCode: '',
				randomCode: ''
			}
		},
		methods: {
			startCountdown() {
				this.countdownState = true;
				this.countdownValue = this.timeRemaining + '秒后重发';
				let countdownInterval = setInterval(() => {
					this.timeRemaining--;
					this.countdownValue = this.timeRemaining + '秒后重发';
					if (this.timeRemaining <= 0) {
						clearInterval(countdownInterval);
						this.countdownState = false;
						this.timeRemaining = 60;
						this.countdownValue = '获取验证码';
					}
					// 使用Vue的响应式特性自动更新视图
				}, 1000);
			},
			countdown() {
				if (this.telephone.length != 11 || isNaN(this.telephone)) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '手机号不正确'
					});
					return false;
				}
				this.randomCode = Math.floor(Math.random() * 10000).toString();
				let self = this;
				self.$axios.post('/api/Util/SendUniSMS', {
					"to": this.telephone,
					"signature": '进销云端',
					"templateId": "pub_verif_basic",
					"templateData": {
						"code": self.randomCode.toString(),
						"ttl": "15"
					}
				}).then(function(result) {
					if (result.state == 0) {
					    self.$Notice.error({
					        title: '错误提示',
					        duration: 3,
					        desc: response.errorMsg
					    });
					    return;
					}
					if (result.data.data.code == '105300') {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "每小时限制发送3条验证码"
						});
						return;
					}
					if (result.data.data.code != '0') {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: result.data.data.message
						});
						return;
					}
					self.$Notice.success({
						title: '成功提示',
						duration: 3,
						desc: "短信发送可能有些延迟，请耐心等待"
					});
					setTimeout(function() {
						self.randomCode = '';
					}, 900000)
					self.startCountdown();
				}).catch(err => {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "发送验证码失败"
					});
				})
			},
			inputChange(val) {
				this.$emit('result', {
					value: this.checkCode,
					randomCode: this.randomCode
				});
			}
		}
	}
</script>

<style>
	.check-code-input {
		width: 57%;
		display: inline-block;
		margin-right: 10px;
	}

	.check-code-button {
		width: 43;
		display: inline-block;
	}
</style>